export const config = {
  api_local: process.env.REACT_APP_API_URL,
  BE_API_URL: process.env.REACT_APP_API_URL,
  site: process.env.REACT_APP_SITE,
  LIST_REQUEST_BANK: [
    "Xóa số tài khoản",
    "Thêm số tài khoản",
    "Đổi số tài khoản",
  ],
  LIST_REQUEST_USDT: ["Xóa Ví USDT", "Thêm Ví USDT", "Đổi Ví USDT"],
  LIST_USDT_WALLET: ["USDT-ERC20", "USDT-TRC20", "USDT-BEP20"],
};
